import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useSubscription } from '../../hooks/useSubscription'
import { toast } from 'react-toastify'
import arabicBg from '../../images/arabic-bg-dark.svg'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n';
import './style.css'

const BlogSection = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const { isPaidSubscription, hasActiveSubscription } = useSubscription();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleEnrollClick = (e) => {
        e.preventDefault();
        ClickHandler();

        if (!isAuthenticated) {
            // Redirect to subscribe page for unauthenticated users
            navigate("/subscribe");
        } else if (isPaidSubscription) {
            toast.info('You already have a premium subscription!');
            navigate("/dashboard");
        } else {
            // Allow demo users to upgrade
            navigate("/subscribe");
        }
    }

    return (
        <section
            className="wpo-blog-section"
            style={{
                position: 'relative'
            }}
        >
            {/* Arabic Background */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${arabicBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.05,
                    zIndex: 0
                }}
            />
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="section-title-s4">
                            <span>{t('blogSection.ourBundles')}</span>
                            <h2>{t('blogSection.affordablePricings')}</h2>
                            <div className="transparent-text">{t('blogSection.bundlesTransparent')}</div>
                        </div>
                    </div>
                </div>

                <div className="row wpo-bundles">
                    {/* Bundle 1 */}
                    <div className="col col-lg-4 col-md-6 col-12">
                        <div className="wpo-bundle-card">
                            <h3 className="wpo-bundle-title">{t('blogSection.subscriptionTitle')}</h3>
                            <div className="wpo-bundle-sub">{t('blogSection.subscriptionPrice')}</div>
                            <div className="wpo-bundle-price"><span className="amount">$49</span><span className="meta">{t('blogSection.subscriptionAnnual')}</span></div>
                            <div className="wpo-bundle-sep"></div>
                            <ul className="wpo-bundle-features">
                                <li><span className="icon">✓</span><span>{t('blogSection.unlimitedAccess')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.learningLevels')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.teachingUnits')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.levelTest')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.interactiveActivities')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.animationVideos')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.evaluationQuizzes')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.funGames')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.talesAndSongs')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.educationalSupport')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.socialNetwork')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.resultsStatistics')}</span></li>
                            </ul>
                            <div className="wpo-bundle-actions">
                                <a href="#" onClick={handleEnrollClick} className="theme-btn-s2">{t('blogSection.enrollNow')}</a>
                            </div>
                        </div>
                    </div>

                    {/* Bundle 2 */}
                    <div className="col col-lg-4 col-md-6 col-12">
                        <div className="wpo-bundle-card emphasis">
                            <h3 className="wpo-bundle-title">{t('blogSection.coursesWithTeacherTitle')}</h3>
                            <div className="wpo-bundle-sub">{t('blogSection.coursesWithTeacherPrice')}</div>
                            <div className="wpo-bundle-price"><span className="amount">$690</span><span className="meta">{t('blogSection.coursesWithTeacherAnnual')}</span></div>
                            <div className="wpo-bundle-sep"></div>
                            <ul className="wpo-bundle-features">
                                <li><span className="icon">✓</span><span>{t('blogSection.lessonsPerMonth')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.unlimitedAccess')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.learningLevels')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.teachingUnits')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.levelTest')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.interactiveActivities')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.animationVideos')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.evaluationQuizzes')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.funGames')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.talesAndSongs')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.educationalSupport')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.socialNetwork')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.resultsStatistics')}</span></li>
                            </ul>
                            <div className="wpo-bundle-actions">
                                <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">{t('blogSection.contactUs')}</Link>
                            </div>
                        </div>
                    </div>

                    {/* Bundle 3 */}
                    <div className="col col-lg-4 col-md-6 col-12">
                        <div className="wpo-bundle-card">
                            <h3 className="wpo-bundle-title">{t('blogSection.schoolOfferTitle')}</h3>
                            <p className="wpo-bundle-sub" style={{ marginBottom: 0 }}>{t('blogSection.schoolOfferDescription')}</p>
                            <div className="wpo-bundle-sep"></div>
                            <ul className="wpo-bundle-features">
                                <li><span className="icon">✓</span><span>{t('blogSection.schoolCustomization')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.studentEvaluation')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.detailedDashboard')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.managerAccompaniment')}</span></li>
                                <li><span className="icon">✓</span><span>{t('blogSection.technicalAssistance')}</span></li>
                            </ul>
                            <div className="wpo-bundle-actions">
                                <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">{t('blogSection.contactUs')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BlogSection;